import React from 'react';
import Layout from '@/components/Layout';
import SEO from '@/components/SEO';

const TermsOfUse = () => {
  // Schema.org עבור דף תנאי שימוש
  const termsPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "תנאי שימוש |  שלומית ז'בנר",
    "description": "תנאי השימוש של  שלומית ז'בנר מגדירים את הכללים והזכויות בעת השימוש באתר שלנו ובשירותים שאנו מציעים.",
    "publisher": {
      "@type": "Organization",
      "name": "שלומית ז'בנר",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.yourwebsite.com/logo.png"
      }
    },
    "inLanguage": "he-IL",
    "datePublished": "2025-03-01",
    "dateModified": "2025-03-01"
  };

  return (
    <>
      <SEO 
        title="תנאי שימוש | שלומית ז'בנר "
        description="תנאי השימוש של שלומית ז'בנר  מגדירים את הכללים והזכויות שלך בעת השימוש באתר ובשירותים שלנו."
        keywords="תנאי שימוש, הסכם משתמש, כללי שימוש, תקנון אתר, זכויות יוצרים, הגבלת אחריות"
        canonicalUrl="/terms-of-use"
        structuredData={termsPageSchema}
      />
      <Layout>
        <div className="sr-only" id="main-content">תוכן תנאי השימוש מתחיל כאן</div>
        <main id="main-content" role="main" aria-labelledby="main-heading">
          <div className="container mx-auto px-6 py-12 md:py-20 max-w-4xl">
            <h1 id="main-heading" className="text-3xl md:text-4xl font-bold mb-8 text-tech-darkGray text-center">תנאי שימוש</h1>
            
            <div className="bg-white rounded-xl p-8 shadow-sm space-y-6">
              <nav aria-label="תוכן עניינים" className="bg-tech-gray p-4 rounded-lg mb-8">
                <h2 className="text-xl font-bold mb-2 text-tech-darkGray">תוכן עניינים</h2>
                <ul className="space-y-1 list-inside">
                  <li><a href="#agreement" className="text-tech-blue hover:underline">1. הסכמה לתנאים</a></li>
                  <li><a href="#changes" className="text-tech-blue hover:underline">2. שינויים בתנאים</a></li>
                  <li><a href="#site-usage" className="text-tech-blue hover:underline">3. השימוש באתר</a></li>
                  <li><a href="#intellectual-property" className="text-tech-blue hover:underline">4. קניין רוחני</a></li>
                  <li><a href="#license" className="text-tech-blue hover:underline">5. רישיון שימוש</a></li>
                  <li><a href="#content-accuracy" className="text-tech-blue hover:underline">6. דיוק תוכן</a></li>
                  <li><a href="#limitation" className="text-tech-blue hover:underline">7. הגבלת אחריות</a></li>
                  <li><a href="#links" className="text-tech-blue hover:underline">8. קישורים לאתרים אחרים</a></li>
                  <li><a href="#jurisdiction" className="text-tech-blue hover:underline">9. סמכות שיפוט</a></li>
                  <li><a href="#contact" className="text-tech-blue hover:underline">10. יצירת קשר</a></li>
                </ul>
              </nav>

              <section id="agreement" className="space-y-4" aria-labelledby="agreement-heading">
                <h2 id="agreement-heading" className="text-2xl font-bold text-tech-darkGray">1. הסכמה לתנאים</h2>
                <p className="text-gray-600">
                  ברוכים הבאים לאתר של  שלומית ז'בנר. בגישה או בשימוש באתר שלנו, אתה מסכים לציית לתנאי השימוש הללו. אם אינך מסכים לתנאים אלו, אנא הימנע משימוש באתר שלנו.
                </p>
              </section>

              <section id="changes" className="space-y-4" aria-labelledby="changes-heading">
                <h2 id="changes-heading" className="text-2xl font-bold text-tech-darkGray">2. שינויים בתנאים</h2>
                <p className="text-gray-600">
                  אנו שומרים לעצמנו את הזכות לשנות או לעדכן את תנאי השימוש הללו בכל עת לפי שיקול דעתנו הבלעדי. שינויים אלה ייכנסו לתוקף מיד עם פרסומם באתר. המשך השימוש שלך באתר לאחר שינויים כאלה מהווה את הסכמתך לתנאים המעודכנים.
                </p>
              </section>

              <section id="site-usage" className="space-y-4" aria-labelledby="site-usage-heading">
                <h2 id="site-usage-heading" className="text-2xl font-bold text-tech-darkGray">3. השימוש באתר</h2>
                <p className="text-gray-600">
                  אתה מסכים להשתמש באתר שלנו רק למטרות חוקיות ובהתאם לתנאים אלה. אתה מסכים לא להשתמש באתר שלנו:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 pr-4">
                  <li>בכל דרך המפרה כל חוק או תקנה מקומית, לאומית או בינלאומית</li>
                  <li>בכל דרך שהיא לא חוקית, מרמה, או יש לה כל מטרה או השפעה לא חוקית או זדונית</li>
                  <li>להעביר, או לגרום לשליחה של, כל חומר פרסומי או קידום מכירות לא מורשה או לא מבוקש</li>
                  <li>להעביר ביודעין כל נתונים, לשלוח או להעלות כל חומר המכיל וירוסים, סוסים טרויאנים, תולעים, פצצות זמן, מקלידי מקשים, או כל תוכנה מזיקה אחרת</li>
                </ul>
              </section>

              <section id="intellectual-property" className="space-y-4" aria-labelledby="intellectual-property-heading">
                <h2 id="intellectual-property-heading" className="text-2xl font-bold text-tech-darkGray">4. קניין רוחני</h2>
                <p className="text-gray-600">
                  אנו בעלי כל הזכויות, הבעלות והאינטרסים באתר, כולל כל זכויות הקניין הרוחני. התוכן של האתר, כולל, אך לא מוגבל לטקסט, גרפיקה, לוגואים, סימנים, תמונות, קליפים אודיו, הורדות דיגיטליות, ואוספי נתונים, הוא הרכוש של שלומית ז'בנר  או של ספקי התוכן שלנו ומוגן על ידי חוקי זכויות יוצרים וסימני מסחר.
                </p>
              </section>

              <section id="license" className="space-y-4" aria-labelledby="license-heading">
                <h2 id="license-heading" className="text-2xl font-bold text-tech-darkGray">5. רישיון שימוש</h2>
                <p className="text-gray-600">
                  אנו מעניקים לך רישיון מוגבל, לא בלעדי, לא ניתן להעברה ולא ניתן לרישיון משנה לגשת ולהשתמש באתר לשימושך האישי, הלא מסחרי. רישיון זה אינו כולל:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 pr-4">
                  <li>שימוש חוזר בכל תוכן מהאתר שלנו</li>
                  <li>מכירה, השכרה או רישיון משנה של חומר מהאתר</li>
                  <li>שכפול, שכפול או העתקה של חומר מהאתר</li>
                  <li>הפצה מחדש של תוכן מהאתר שלנו</li>
                </ul>
              </section>

              <section id="content-accuracy" className="space-y-4" aria-labelledby="content-accuracy-heading">
                <h2 id="content-accuracy-heading" className="text-2xl font-bold text-tech-darkGray">6. דיוק תוכן</h2>
                <p className="text-gray-600">
                  בעוד שאנו שואפים לוודא שהמידע באתר שלנו הוא מדויק, עדכני ומלא, איננו מתחייבים כי התוכן באתר שלנו עומד בדרישות אלה. תוכן האתר ניתן "כפי שהוא" ו"כפי שהוא זמין" ללא כל ייצוג או אישור. אנו שומרים לעצמנו את הזכות לשנות את תוכן האתר בכל עת ללא הודעה מוקדמת.
                </p>
              </section>

              <section id="limitation" className="space-y-4" aria-labelledby="limitation-heading">
                <h2 id="limitation-heading" className="text-2xl font-bold text-tech-darkGray">7. הגבלת אחריות</h2>
                <p className="text-gray-600">
                  בשום מקרה לא נהיה אחראים לכל אובדן או נזק, כולל, ללא הגבלה, אובדן או נזק עקיף או תוצאתי, או כל אובדן או נזק הנובעים מאובדן נתונים או רווחים הנובעים מהשימוש או חוסר היכולת להשתמש באתר שלנו.
                </p>
              </section>

              <section id="links" className="space-y-4" aria-labelledby="links-heading">
                <h2 id="links-heading" className="text-2xl font-bold text-tech-darkGray">8. קישורים לאתרים אחרים</h2>
                <p className="text-gray-600">
                  האתר שלנו עשוי להכיל קישורים לאתרים אחרים שאינם בבעלותנו או בשליטתנו. לא תהיה לנו כל אחריות על התוכן, מדיניות הפרטיות או הנהלים של כל אתר צד שלישי. איננו אחראים לכל אובדן או נזק שעלול לנבוע מהשימוש באתרים אלה.
                </p>
              </section>

              <section id="jurisdiction" className="space-y-4" aria-labelledby="jurisdiction-heading">
                <h2 id="jurisdiction-heading" className="text-2xl font-bold text-tech-darkGray">9. סמכות שיפוט</h2>
                <p className="text-gray-600">
                  תנאי שימוש אלה יהיו כפופים ויפורשו בהתאם לחוקי מדינת ישראל, ללא התחשבות בעקרונות התנגשות החוקים שלה. כל מחלוקת הנובעת מתנאים אלה תהיה כפופה לסמכות השיפוט הבלעדית של בתי המשפט במדינת ישראל.
                </p>
              </section>

              <section id="contact" className="space-y-4" aria-labelledby="contact-heading">
                <h2 id="contact-heading" className="text-2xl font-bold text-tech-darkGray">10. יצירת קשר</h2>
                <p className="text-gray-600">
                  אם יש לך שאלות כלשהן בנוגע לתנאי שימוש אלה, אנא צור איתנו קשר באמצעות:
                </p>
                <div className="bg-tech-gray p-4 rounded-lg">
                  <p className="text-gray-600">דוא"ל: <a href="mailto:support@zabnerit.com" className="text-tech-blue hover:underline">support@zabnerit.com</a></p>
                  <p className="text-gray-600">טלפון: <a href="tel:050-123-4567" className="text-tech-blue hover:underline">050-123-4567</a></p>
                </div>
              </section>

              <p className="text-gray-500 text-sm mt-8 text-center">
                עדכון אחרון: מרץ 2025
              </p>
            </div>
          </div>
        </main>
      </Layout>
    </>
  );
};

export default TermsOfUse;